// extracted by mini-css-extract-plugin
module.exports =  {"recsContainer":"pl__Recs-module__recsContainer___yaQN6"};